import { gql } from "apollo-boost";

export const VALIDATE_HOME_CLAIM = gql`
  mutation validateHomeClaim(
    $user_id: ID!
    $property_id: ID!
    $owner_name: String!
  ) {
    validate_home_claim(
      input: {
        user_id: $user_id
        property_id: $property_id
        owner_name: $owner_name
      }
    ) {
      id
    }
  }
`;
